// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"113":"774ca841446985e030f5","674":"0dfbe4952738aa7c13f4"}[chunkId] + ".bundle.js";
};